import { Fragment } from "react";

interface propsTypes {
  children?: React.ReactNode;
  className?: string;
  innerHtml?: string;
  onClick?: () => void;
  dangerouslySetInnerHTML?: any;
  id?: string;
  style?: {
    fontSize?: number | string;
    fontWeight?: number;
    color?: string;
    opacity?: string;
    margin?: number;
    lineHeight?: number | string;
    zIndex?: string | number;
    whiteSpace?: string;
    animationDelay?: any;
  };
}

const P = (props: propsTypes) => {
  return (
    <Fragment>
      <p {...props}>{props.children}</p>
    </Fragment>
  );
};

export default P;
